import { render } from "./MovingMemo.vue?vue&type=template&id=5bbbee0e"
import script from "./MovingMemo.vue?vue&type=script&lang=js"
export * from "./MovingMemo.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__